import { Form } from "antd";
import { useAppSelector } from "core/utils";

import type { FieldMethod, FormFieldFactoryProps, SelectDynamicFormField } from "../../types/types";
import { SelectDynamic } from "../index";

export const SelectDynamicField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    // Apply a spinner to SiteGroup field to resolve when PropertyGroups are loaded
    const isDynamicPropertiesLoading = useAppSelector((state) => state.dynamicPropertiesLoading?.isLoading);
    const isSpinning = isDynamicPropertiesLoading && field.name === "parentUnit";

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <SelectDynamic
                key={field.name}
                name={field.name}
                label={field.translationKeys.label}
                fieldConfig={field as SelectDynamicFormField}
                readOnly={readOnly}
                isSpinning={isSpinning}
            />
        </Form.Item>
    );
};
